import { createClient } from "@supabase/supabase-js";

/**
 * Supabase Auth Google Sign-in (2026-08) — replaces the Emergent-managed
 * broker (auth.emergentagent.com). Google OAuth now runs through C-ORE's
 * OWN Google Cloud OAuth client, configured directly in Supabase Dashboard
 * > Authentication > Providers > Google — the consent screen shows "C-ORE"
 * branding instead of "Emergent".
 *
 * REACT_APP_SUPABASE_ANON_KEY is the public "anon" key — safe to ship in
 * browser code (it's the same key already used by the rest of the app's
 * read paths). It is NOT the service-role secret.
 */
export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      flowType: "pkce",
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
